import { useEffect, useRef, useState } from "react";
import { me } from "@/game/api";

// restores the saved session on mount and listens for the global logout event
export function useSession(onLoggedOut) {
  const [player, setPlayer] = useState(null);
  const onLoggedOutRef = useRef(onLoggedOut);
  onLoggedOutRef.current = onLoggedOut;

  useEffect(() => {
    me().then((p) => p && setPlayer(p));
    const onLogout = () => {
      setPlayer(null);
      onLoggedOutRef.current();
    };
    window.addEventListener("tb-logout", onLogout);
    return () => window.removeEventListener("tb-logout", onLogout);
  }, []);

  return [player, setPlayer];
}

export function useSettings() {
  const [soundOn, setSoundOn] = useState(true);
  const [showKeyboard, setShowKeyboard] = useState(true);
  const soundEnabledRef = useRef(true);

  const toggleSound = () => {
    setSoundOn((s) => {
      soundEnabledRef.current = !s;
      return !s;
    });
  };

  return { soundEnabledRef, soundOn, toggleSound, showKeyboard, setShowKeyboard };
}
